<script setup lang="ts">
</script>
<template>
    <main>
        <!--Page-->
        <section class="container-full-5">
            
            <h2 class="secondary-font gap-4 mt-2 mb-6">
            Mes Commandes
            </h2>

            <!--Commande-->
            <a href="">
                <div class="card flex-mobile align-items-center px-6 py-1 border-grey mb-5">
                    <div class="s7_mobile my-6">
                        <h3 class="secondary-font text-grey-800 mb-3">#COM123456</h3>
                        <h5 class="text-grey-600 secondary-font mb-3">600 0000 F CFA</h5>
                        <p class="font-semibold secondary-font text-medium text-grey-600 mb-4">12 Juin 2024</p>
                        <span class="tag-state notif stroke">Livré</span>
                    </div>
                    <div class="s13_mobile text-right">
                        <img src="/public/assets/produits/1000wp/produit1.png" width="32%" />
                        <img src="/public/assets/produits/1000wp/produit10.png" width="32%" />
                        <img src="/public/assets/produits/1000wp/produit12.png" width="32%" />
                    </div>
                </div>
            </a>
            <!--End Commande-->

            <a href="">
                <div class="card flex-mobile align-items-center px-6 py-1 border-grey mb-5">
                    <div class="s7_mobile my-6">
                        <h3 class="secondary-font text-grey-800 mb-3">#COM123456</h3>
                        <h5 class="text-grey-600 secondary-font mb-3">600 0000 F CFA</h5>
                        <p class="font-semibold secondary-font text-medium text-grey-600 mb-4">12 Juin 2024</p>
                        <span class="tag-state notif stroke">Livré</span>
                    </div>
                    <div class="s13_mobile text-right">
                        <img src="/public/assets/produits/1000wp/produit8.png" width="32%" />
                    </div>
                </div>
            </a>

            <div class="clear-both h-70"></div>
        </section>
    </main>
</template>